import simpleRestProvider from 'ra-data-simple-rest';
import fakeRestProvider from 'ra-data-fakerest';
import DummyData from './DummyData';
import { fetchUtils } from 'react-admin';
import CommonHttpError from './components/common/CommonHttpError';

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    options.credentials = 'include';
    return fetchUtils.fetchJson(url, options)
        .catch((e) => {
            CommonHttpError(e);
        });
}
const dataProvider = (process.env.NODE_ENV === "development") ? fakeRestProvider(DummyData, true)
    : simpleRestProvider(process.env.REACT_APP_RSB_API_ENDPOINT, httpClient);

export default dataProvider;